<template>
    <path fill-rule="evenodd" d="M3 26c1.656 0 3 1.344 3 3s-1.343 3-3 3c-1.656 0-3-1.344-3-3s1.343-3 3-3zm0-13c1.656 0 3 1.344 3 3s-1.343 3-3 3c-1.656 0-3-1.344-3-3s1.343-3 3-3zM3 0c1.656 0 3 1.344 3 3S4.657 6 3 6C1.344 6 0 4.656 0 3s1.343-3 3-3z"/>
</template>

<script>
export default {
    name: 'separatorIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 6 32');
    }
};
</script>
